import React from "react";

import {
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";



function StatCard({
  title,
  value,
  icon,
  color="#2563eb",
}) {


  return (

    <Card

      elevation={1}

      sx={{

        height:120,

        borderRadius:3,

        background:"#ffffff",

        border:"1px solid #e5e7eb",

        transition:"0.3s",

        "&:hover":{

          transform:"translateY(-3px)",

          boxShadow:4

        }

      }}

    >



      <CardContent

        sx={{

          p:2.5

        }}

      >



        <Box

          display="flex"

          justifyContent="space-between"

          alignItems="center"

        >



          <Box>


            <Typography

              variant="body2"

              sx={{

                color:"#64748b",

                fontWeight:600,

                fontSize:14

              }}

            >

              {title}

            </Typography>





            <Typography

              variant="h4"

              sx={{

                mt:1,

                fontWeight:700,

                color:"#0f172a",

                fontSize:34

              }}

            >

              {value}

            </Typography>



          </Box>






          <Box

            sx={{

              width:52,

              height:52,

              borderRadius:"50%",

              backgroundColor:`${color}20`,

              color:color,

              display:"flex",

              alignItems:"center",

              justifyContent:"center"

            }}

          >

            {icon}

          </Box>



        </Box>



      </CardContent>


    </Card>

  );

}


export default StatCard;